/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
class t{constructor(t,s,o,r){this.toMapSpace=t,this.transform=s,this.obb=o,this.geometry=r}}export{t as ObjectParameters};
